// Shared "Jobs" tab label so all three company-detail pages show the same
// pill-badge count instead of each inlining its own markup.
const JobsTabLabel = ({ jobsCount }) => (
    <>
        Jobs
        {Number(jobsCount) > 0 && (
            <span className="company-detail-jobs-badge ms-1">{jobsCount}</span>
        )}
    </>
);

export default JobsTabLabel;
